import {Component, OnInit} from '@angular/core';
import {ReviewTransmissionService} from "../../raintree/transmission/review-transmission.service";
import {IReviewStats} from "../interface/review-stats";

@Component({
	selector: 'fb-review',
	templateUrl: './review.component.html',
	styleUrls: ['./review.component.scss']
})
export class ReviewComponent implements OnInit {

	protected stars: boolean[] = Array(5).fill(0);
	protected rating: number = 0;
	protected reviewCount: number = 0;

	constructor(
		private _api: ReviewTransmissionService
	) {
	}

	ngOnInit(): void {
		this.resolveReviewStats();
	}

	private resolveReviewStats(): void {
		this._api.getReviewStats(
			() => {
			},
			() => {
			},
			(response: IReviewStats) => {
				this.reviewCount = response.count;
				this.rating = response.rating;
			},
			(error: string) => {
			},
			() => {
			}
		);
	}
}
